import { Flex, Text } from "@chakra-ui/react";

function CompanyInfo() {
  return (
    <Flex
      w="100%"
      h={"198px"}
      bg="#fafafa"
      px="20px"
      flexDirection="column"
      justifyContent={"center"}
    >
      <Text fontSize="13px" color="#4d4d4d" fontWeight={"bold"}>
        민트멤버스 주식회사
      </Text>
      <Text whiteSpace={"pre-wrap"} fontSize="12px" color="#9e9e9e" mt={"8px"}>
        {"대표: 장고든 | 개인정보보호책임자 : 유성철\n" +
          "주소: 서울특별시 강남구 역삼로 557, 제니스타워 3층\n" +
          "사업자등록번호 : 152-81-02496\n" +
          "통신판매업신고 : 제 2022-서울강남-04046호"}
      </Text>

      <Text fontSize="10px" color="#9e9e9e" mt={"13px"}>
        ⓒ 2022 Mint Members Co., Ltd. All rights reserved.
      </Text>
    </Flex>
  );
}
export default CompanyInfo;
